<template>
  <!-- 汇丰，中智信开票 -->
  <NonoInvoice />
</template>
<script>
export default {
  name: 'nonoInvoice'
}
</script>
